/* Remove lazy loading on ACF Module "Customer Section" since images there is outside screen and not showing on mobile if has element lazy. And using 4th param on wp_get_attachment_image setting loading=false did not work */

jQuery( function( $ ) {
	$( document ).ready( function() {
		$( '.customer-section__logo img' ).removeAttr( 'loading' );
	} );
} );
